
export const copyToClipboard = (content: string) => {
    navigator.clipboard.writeText(content)

}